export const CHAT_SET_NUM_UNREAD_CONVERSATIONS =
  'CHAT_SET_NUM_UNREAD_CONVERSATIONS';
